import { useRouter } from 'vue-router';

import type { ApiTabValueType } from './types';

export default function useApiRoutes() {
  const router = useRouter();

  function openTab(tab: ApiTabValueType) {
    return router.push({ name: 'api', params: { tab } });
  }

  return { openTab };
}
